import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { notificationsReducer } from './store/reducers/notifications.reducer';
import { appReducer } from './store/reducers/app.reducer';
import { partnersReducer } from './store/reducers/partners.reducer';
import { companiesReducer } from './store/reducers/companies.reducer';

import { NotificationsEffects } from './store/effects/notifications.effects';
import { PermissionsEffects } from './store/effects/permissions.effects';
import { RolesEffects } from './store/effects/roles.effects';
import { CompaniesEffects } from './store/effects/companies.effects';
import { PartnersEffects } from './store/effects/partners.effects';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { CompanyService } from './shared/services/company/company.service';
import { PermissionService } from './shared/services/permission/permission.service';
import { ConfigService } from './shared/services/config/config.service';
import { InstructionService } from './shared/services/instruction/instruction.service';
import { InvoiceService } from './shared/services/invoice/invoice.service';

import { ApiService } from './shared/services/api/api.service';

import { OperationsService } from './shared/services/operations/operations.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION } from "ngx-ui-loader";
//import { PdfViewerModule } from 'ng2-pdf-viewer';

import { NotifierService, NotifierModule  } from 'angular-notifier';
import { DecimalPipe } from '@angular/common';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: "#017ac2",
  bgsPosition: POSITION.bottomCenter,
  hasProgressBar: false,
  bgsSize: 40,
  fgsType: SPINNER.ballScaleMultiple, // background spinner type
  pbThickness: 5, // progress bar thickness
  overlayColor: 'rgb(242 243 246 / 35%)',
  minTime: 100,
  delay: 0
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    StoreModule.forRoot(appReducer),
    EffectsModule.forRoot([NotificationsEffects, PermissionsEffects, RolesEffects, PartnersEffects, CompaniesEffects]),
    SharedModule,
    NotifierModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp : ['/payout/instructions/pending-approval', '/invoice/pending-approval']
     }),
    //PdfViewerModule,
  ],
  exports: [
  ],
  providers: [
    CompanyService,
    ConfigService,
    NotifierService,
    InstructionService,
    InvoiceService,
    ApiService,
    OperationsService,
    DecimalPipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
